import { render, staticRenderFns } from "./editAdditionalForm.vue?vue&type=template&id=78d51020&scoped=true&"
import script from "./editAdditionalForm.vue?vue&type=script&lang=js&"
export * from "./editAdditionalForm.vue?vue&type=script&lang=js&"
import style0 from "./editAdditionalForm.vue?vue&type=style&index=0&id=78d51020&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d51020",
  null
  
)

export default component.exports